export const DISABLE_AUTH = false;

export const ENABLE_INLINE_EDIT =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_ENABLE_INLINE_EDIT === 'true') ||
  (typeof process !== 'undefined' && process.env?.VITE_ENABLE_INLINE_EDIT === 'true');
